export default function ForgotUsername() {
  return (
    <div className="w-full h-screen flex items-center justify-center bg-black text-white">
      <div className="text-center p-8 bg-white/5 rounded-2xl border border-white/20 max-w-md">
        <h2 className="text-2xl font-bold mb-4">Forgot Username</h2>
        <p className="text-white/80">Your username is the email you used to register.</p>
        <a href="/login" className="mt-6 inline-block text-purple-400 hover:text-purple-300 underline">
          Back to Login
        </a>
      </div>
    </div>
  );
}
